import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import { TutorialSummaryPropTypes } from 'components/generic/CourseSummary/propTypes'
import LazyWrapper from 'components/generic/LazyWrapper'
import Tutorial from '../../generic/CourseSummary'
import './styles.css'

export function CourseRelated({ courses, tags }) {
  return (
    <section id="course-related">
      <div className="title"><h3 className="title__text">Related Courses</h3></div>
      <div className="courses-list">
        {courses.map((tutorial) => (
          <Tutorial
            className="tutorial"
            key={`tutorial-${tutorial.id}`}
            slug={tutorial.slug}
            summary={tutorial.description}
            teacher={tutorial.artist.title}
            teacherSlug={tutorial.artist.slug}
            thumb={tutorial.photo.boxThumb}
            title={tutorial.title}
            new={tutorial.new}
          />
        ))}
      </div>
      <Link className="see-more" to={`/search?q=${encodeURIComponent(tags.join(','))}`}>
        <i className="icon-plus" /> see more courses
      </Link>
    </section>
  )
}

function CourseRelatedLazyWrapper(props) {
  return (
    <LazyWrapper>
      <CourseRelated {...props} />
    </LazyWrapper>
  )
}

CourseRelated.propTypes = {
  courses: PropTypes.arrayOf(PropTypes.shape(TutorialSummaryPropTypes))
    .isRequired,
  tags: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default CourseRelatedLazyWrapper
